import { Segmented, SegmentedProps } from 'antd';
import { TFunction } from 'i18next';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CreateTicketFormValues } from '../../../types/form';
import useCurrentTicket from '../../hooks/ticketDetailPage/useCurrentTicket';
import {
    SetStateType,
    channelGSocialChatTypeMap,
    channelGSocialType,
    channelGSocialTypeMap,
    channelType,
    channelTypeMap,
    commentType,
    commentTypeOptionsMap,
    ticketInteractionViewOptionsMap,
    ticketInteractionViewViewType
} from '../../model/types';

interface CommentTypeSelectProps {
    setCommentsViewType?: SetStateType<ticketInteractionViewViewType>;
}

function isChannelGSocial(channel: channelType) {
    return !!channelGSocialTypeMap[channel];
}
export function isChannelGSocialChat(channel: channelType) {
    return !!channelGSocialChatTypeMap[channel];
}

function getCommentOptions(channel: channelType, t: TFunction): SegmentedProps['options'] {
    const options = Object.keys(commentTypeOptionsMap).map((commentType: commentType) => ({
        label: t('comment' as any, { context: commentType }),
        value: (commentType === 'public').toString()
    }));

    if (isChannelGSocial(channel)) options.push({ label: t(`channelNames.${channel}`), value: channel });

    return options;
}

export default function CommentTypeSelect({ setCommentsViewType }: CommentTypeSelectProps) {
    const { t } = useTranslation('tickets');
    const { data } = useCurrentTicket();
    const channel = data?.channel;

    const { setValue } = useFormContext<CreateTicketFormValues>();
    const watchedCommentType = useWatch<CreateTicketFormValues, 'comment.publicVisible'>({
        name: 'comment.publicVisible'
    });

    const watchedCommentChannelType = useWatch<CreateTicketFormValues, 'comment.channel'>({
        name: 'comment.channel'
    });

    const handleOnChange = (value: channelGSocialType | 'true' | 'false') => {
        setValue('comment.publicVisible', !(value === 'false'), { shouldValidate: true });
        setValue('comment.channel', channelGSocialTypeMap[value] ?? channelTypeMap.WEB);

        if (isChannelGSocialChat(value as channelType) && setCommentsViewType) {
            setCommentsViewType(ticketInteractionViewOptionsMap.gsocialChat);
        }
    };

    const segmentedValue = channelGSocialTypeMap[watchedCommentChannelType] ?? watchedCommentType.toString();

    return (
        <Segmented
            size="middle"
            value={segmentedValue}
            options={getCommentOptions(channel, t)}
            onChange={handleOnChange}
        />
    );
}

export { isChannelGSocial };
